import React, { Suspense, useCallback } from 'react';
import { useLazyComponent } from '@trello/use-lazy-component';
import { ErrorBoundary } from 'app/src/components/ErrorBoundary';
import { ChunkLoadErrorBoundary } from 'app/src/components/ChunkLoadErrorBoundary';
import { RequestAccessConfirmationModalProps } from './RequestAccessConfirmationModal';
import { ErrorContentDialog } from './ErrorContentDialog';

export const LazyRequestAccessConfirmationModal: React.FunctionComponent<RequestAccessConfirmationModalProps> = (
  props: RequestAccessConfirmationModalProps,
) => {
  const RequestAccessConfirmationModal = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "request-access-confirmation-modal" */ './RequestAccessConfirmationModal'
      ),
    { preload: false, namedImport: 'RequestAccessConfirmationModal' },
  );

  const errorHandler = useCallback(
    (errorBoundaryProps) => (
      <ErrorContentDialog {...errorBoundaryProps} handleClick={props.onClose} />
    ),
    [props.onClose],
  );

  return (
    <Suspense fallback={null}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-smoothie',
          feature: 'requestAccessV3',
        }}
        errorHandlerComponent={errorHandler}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <RequestAccessConfirmationModal {...props} />
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </Suspense>
  );
};
